import { Component, Input, SimpleChanges } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-aul-104-24",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./aul-104-24.component.html",
  styleUrl: "./aul-104-24.component.scss",
})
export class Aul10424Component {
  @Input() endorsementDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["endorsementDetails"]) {
      // Input can be either:
      // - { aul10424: {...} }
      // - { ... } (already the aul10424 payload)
      const incoming = changes["endorsementDetails"].currentValue;
      this.endorsementDetails = incoming?.aul10424 ?? incoming;
    }
  }

  isNewJerseyEndorsement(): boolean {
    const stateId = Number(this.endorsementDetails?.stateId);
    const state = (this.endorsementDetails?.state || "").toString().toLowerCase().trim();
    return stateId === 30 || state === "new jersey";
  }

  getNJTN(): string {
    if (!this.isNewJerseyEndorsement()) {
      return "";
    }

    const slaNumber = (this.endorsementDetails?.slaNumber ?? "").toString().trim();
    const yearVal = this.endorsementDetails?.njtnYear;
    const njtnVal = this.endorsementDetails?.njtn;

    const yearStrRaw = yearVal === null || yearVal === undefined ? "" : String(yearVal).trim();
    const yearStr =
      yearStrRaw.length === 4 ? yearStrRaw.slice(-2) : yearStrRaw.padStart(2, "0");

    const njtnStrRaw = njtnVal === null || njtnVal === undefined ? "" : String(njtnVal).trim();
    const njtnStr = njtnStrRaw ? njtnStrRaw.padStart(5, "0") : "";

    if (!slaNumber || !yearStrRaw || !njtnStrRaw) {
      return "";
    }

    return `${slaNumber}-${yearStr}-${njtnStr}`;
  }
}
